import { useState } from 'react';
import Main from '../../../component/Main.jsx';
import NewDataGrid from '../../../component/common/dataGrid/NewDataGrid.jsx';
import SearchBtn from '../../../component/common/button/SearchBtn.jsx';
import NewCommonSelect from '../../../component/common/selectBox/NewCommonSelect.jsx';

const OEBdExceptionList = () => {
    // new Date((new Date()).getTime() + 1000 * 60 * 60 * 9 + 1000 * 60 * 60 * 24 * 3).toISOString().split('T')[0]
    const [searchParams, setSearchParams] = useState({
        searchFromdate: new Date((new Date()).getTime() + 1000 * 60 * 60 * 9 - 1000 * 60 * 60 * 24 * 3).toISOString().split('T')[0],
        searchTodate: new Date((new Date()).getTime() + 1000 * 60 * 60 * 9).toISOString().split('T')[0],
        searchEmog: '',
        searchIdno: '',
        searchGrdc: '',
        searchLoca: '',
        searchGubun: '',
    });

    const searchParamsAdditional = {};

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const newParams = {
            ...searchParams,
            [name]: value
        };
        setSearchParams(newParams);
    };

    const dataHead = ['지역', '센터구분', '기관명', '등록번호', '내원일자', '시간', '데이터구분', '예외 전송 기간', '승인상태', '신청사유', '신청일자', '신청시간', '신청자']; //component화 
    const dataColumn = ['EMOGLOCA', 'EMOGGRDC', 'EMOGDESC', 'EMMKMASK', 'EMMKINDTDESC', 'EMMKINTMDESC', 'EMMKDTTYDESC', 'EMMK_FT_TO_DT', 'EMMKOKTY', 'EMMKMEMO', 'EMMKDATE', 'EMMKTIME', 'EMMKUSER'];
    const apiCall = '/trmsapi/sendweb/selectEMIMEMMKList.do';
    const apiCntCall = '/trmsapi/sendweb/selectEMIMEMMKList_Cnt.do';
    const excelFileName = '예외전송승인조회 목록';
    const excelHead = [];

    const propsInfo = {
        dataHead: dataHead,
        dataColumn: dataColumn,
        apiCall: apiCall,
        apiCntCall: apiCntCall,
        excelFileName: excelFileName,
        excelHead: excelHead,
        colWidth: ['7%', '8%', '11%', '8%', '8%', '5%', '5%', '13%', '5%', '12%', '7%', '7%'],
        wrapTF: true,
    }

    const [state, setState] = useState({
        dataList: [],
        isSearched: false,
        isLoading: false
    })

    const [pageInfo, setPageInfo] = useState({
        paginationTF: true,
        currentPage: 1,
        itemsPerPage: 50, // 한 페이지당 보여줄 데이터 수
        totalItems: 0 // 전체 데이터 수
    });

    return (
        <Main>
            <div className="com-search">
                <table>
                    <colgroup>
                        <col width="10%" />
                        <col width="25%" />
                        <col width="7%" />
                        <col width="19%" />
                        <col width="10%" />
                        <col width="19%" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <NewCommonSelect
                                hospitalTF={true}
                                searchParams={searchParams}
                                handleInputChange={handleInputChange}
                            />
                        </tr>
                        <tr>
                            <th>
                                신청기간
                            </th>
                            <td>
                                <input
                                    type="date"
                                    name="searchFromdate"
                                    value={searchParams.searchFromdate}
                                    onChange={handleInputChange}
                                />
                                &nbsp;~&nbsp;
                                <input
                                    type="date"
                                    name="searchTodate"
                                    value={searchParams.searchTodate}
                                    onChange={handleInputChange}
                                    min={searchParams.searchFromdate}
                                />
                            </td>
                            <th>구분</th>
                            <td>
                                <select
                                    id="searchGubun"
                                    name="searchGubun"
                                    className='w-full'
                                    value={searchParams.searchGubun}
                                    onChange={handleInputChange}
                                >
                                    <option value="">전체</option>
                                    <option value="A">승인</option>
                                    <option value="N">미승인</option>
                                    <option value="R">반려</option>
                                    <option value="D">신청취소</option>
                                </select>
                            </td>
                            <th>등록번호</th>
                            <td>
                                <input
                                    type="text"
                                    id="searchIdno"
                                    name="searchIdno"
                                    value={searchParams.searchIdno}
                                    onChange={handleInputChange}
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <SearchBtn
                propsInfo={propsInfo}
                state={state}
                setState={setState}
                searchParams={searchParams}
                searchParamsAdditional={searchParamsAdditional}
                pageInfo={pageInfo}
                setPageInfo={setPageInfo}
            />
            <NewDataGrid
                propsInfo={propsInfo}
                state={state}
                pageInfo={pageInfo}
                setPageInfo={setPageInfo}
            />
        </Main>
    )
}

export default OEBdExceptionList;